/**
 *
 *  ProfilePicture
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types";

import DefaultProfilePic from "./DefaultProfilePic";

const ProfilePictureComponent = ({ className, pictureUrl, size }) => {
  return (
    <div
      className={`profile-picture tbk-h-4 tbk-w-4 tbk-rounded-full ${className}`}
    >
      {pictureUrl ? (
        <img
          className="tbk-rounded-full tbk-object-cover"
          src={pictureUrl}
          alt=""
        />
      ) : (
        <DefaultProfilePic />
      )}
    </div>
  );
};

ProfilePictureComponent.propTypes = {
  pictureUrl: PropTypes.string,
  size: PropTypes.number,
};

export default ProfilePictureComponent;
